

// const BASE_URL = "https://staging.pteshstudios.com";
import "./NewEngineering.css";
import "./serviceEditor.css";
import { NavLink } from "react-router-dom";
import Avatar1 from '../../Images/manpower.jpeg';
import Aboutbg from '../../Images/new_pic_8.png';
import { ServiceEditModal, usePageEditor, resolveUrl } from "./serviceEditorShared";

const servicesNav = [
  { label: "Engineering",                    href: "/engineering" },
  { label: "Procurement",                    href: "/procurement" },
  { label: "Construction",                   href: "/construction" },
  { label: "Installation & Instrumentation", href: "/installation-instrumentation" },
  { label: "Commissioning",                  href: "/commissioning" },
  { label: "Manpower-supply",                href: "/manpower-supply" },
  { label: "Marine Support",                 href: "/marine-support" },
];

const DEFAULT_DATA = {
  bannerImage: "",
  bgImage: "",
  title: "At Jeyshawn Engineering Limited, we provide tailored manpower outsourcing solutions designed to support projects across all stages from start-up to commissioning.",
  paragraphs: [
    "Whether for short-term contract or long-term projects, we deliver a wide range of personnel, including:",
    "Our rigorous selection and training processes ensure that all personnel are competent, reliable, and ready to integrate into client operations immediately. By providing the right people for the right positions, we help clients optimize productivity, maintain quality, and achieve project goals efficiently.",
    "With a commitment to excellence, safety, and professionalism, Jeyshawn Engineering Limited is a trusted partner for manpower solutions, delivering skilled and dependable human resources that drive project success.",
  ],
  sections: [
    {
      heading: "",
      items: [
        "Unskilled, semi-skilled, and skilled workers for general operations.",
        "Technical staff for specialized engineering and operational roles.",
        "Operational and managerial personnel to ensure effective project leadership.",
        "Expert professionals for advisory, supervisory, and strategic roles.",
      ],
    },
  ],
};

export default function ManPower() {
  const { pageData, loading, fetchErr, fetchData, modalOpen, setModalOpen, saving, handleSave, saveMsg } =
    usePageEditor("/api/manpower-supply", DEFAULT_DATA);

  const bannerImg = resolveUrl(pageData.bannerImage) || Avatar1;
  const bgImg     = resolveUrl(pageData.bgImage)     || Aboutbg;

  return (
    <>
      <button className="edit-fab" onClick={() => setModalOpen(true)} title="Edit page content">
        <span className="edit-fab__icon">✏️</span>
        <span className="edit-fab__label">Edit Page</span>
      </button>

      {saveMsg  && <div className="editor-toast">{saveMsg}</div>}
      {loading  && <div className="editor-loading"><div className="editor-loading__spinner" /></div>}
      {fetchErr && <div className="editor-error-banner">{fetchErr}<button onClick={fetchData}>Retry</button></div>}
      {modalOpen && (
        <ServiceEditModal data={pageData} onSave={handleSave} onClose={() => setModalOpen(false)} saving={saving} pageLabel="Manpower Supply" />
      )}

      <div className="img_carrier">
        <img src={bannerImg} alt="" />
      </div>

      <section className="service-detail" style={{ backgroundImage: `url(${bgImg})` }}>
        <div className="service-detail__layout">
          <div className="service-detail__content">
            <h2 className="service-detail__title">{pageData.title}</h2>
            <span className="service-detail__divider" />
            {/* First paragraph before the bullet list */}
            {pageData.paragraphs[0] && (
              <p className="service-detail__intro">{pageData.paragraphs[0]}</p>
            )}
            {pageData.sections.map((sec, i) => (
              <div key={i} className="service-detail__section">
                {sec.heading && <h3 className="service-detail__section-heading">{sec.heading}</h3>}
                <ul className="service-detail__list">
                  {sec.items.map((item, j) => <li key={j} className="service-detail__list-item">{item}</li>)}
                </ul>
              </div>
            ))}
            {/* Remaining paragraphs after the bullet list */}
            {pageData.paragraphs.slice(1).map((p, i) => (
              <p key={i + 1} className="service-detail__intro">{p}</p>
            ))}
          </div>
          <nav className="service-detail__tabs" aria-label="Service navigation">
            {servicesNav.map((s) => (
              <NavLink key={s.href} to={s.href} className={({ isActive }) => `service-detail__tab${isActive ? " service-detail__tab--active" : ""}`}>
                {s.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </section>
    </>
  );
}
